import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import loadingReducer from './slices/loadingSlice';
import localesReducer from './slices/localesSlice';
import projectReducer from './slices/projectSlice';
import historyReducer from './slices/historySlice';
import reportGenerationReducer from './slices/reportGenerationSlice';
import { emptyApiSlice } from './api/emptyApiSlice';
export const store = configureStore({
  reducer: {
    api: emptyApiSlice.reducer,
    user: userReducer,
    loading: loadingReducer,
    locales: localesReducer,
    project: projectReducer,
    history: historyReducer,
    reportGeneration: reportGenerationReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(emptyApiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
